import { useState } from "react";
import { supabase } from "../supabaseClient";
import "../App.css";

const SITE_URL = "https://lupha.duckdns.org";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [mode, setMode] = useState("login"); // "login" | "forgot"
  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setResetLoading] = useState(false);
  const [resetMessage, setResetMessage] = useState(null);
  const [resetError, setResetError] = useState(null);

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message);
    setLoading(false);
  }

  function openForgotPassword() {
    setResetEmail(email);
    setResetMessage(null);
    setResetError(null);
    setMode("forgot");
  }

  function backToLogin() {
    setMode("login");
    setResetMessage(null);
    setResetError(null);
  }

  async function handleResetRequest(e) {
    e.preventDefault();
    setResetLoading(true);
    setResetMessage(null);
    setResetError(null);

    const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
      redirectTo: SITE_URL,
    });

    if (error && error.status === 429) {
      setResetError("Too many requests. Please wait a few minutes and try again.");
    } else {
      // Always show the same message otherwise, whether or not the email is
      // registered, so we don't reveal which addresses have accounts.
      if (error) console.error("Password reset error:", error.message);
      setResetMessage("If an account exists for that email, a reset link is on its way.");
    }
    setResetLoading(false);
  }

  if (mode === "forgot") {
    return (
      <div className="login-page">
        <div className="login-card">
          <div className="login-header">
            <div className="login-logo">👶</div>
            <h1 className="login-title">Reset Password</h1>
            <p className="login-subtitle">We'll email you a link to set a new password</p>
          </div>

          <form className="login-form" onSubmit={handleResetRequest}>
            {resetError && <div className="error-banner">⚠️ {resetError}</div>}
            {resetMessage && <div className="message-success">✅ {resetMessage}</div>}

            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                className="form-input"
                type="email"
                placeholder="your@email.com"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                required
              />
            </div>

            <button className="login-btn" type="submit" disabled={resetLoading}>
              {resetLoading ? "Sending..." : "Send Reset Link"}
            </button>

            <p className="signup-login-link">
              <button type="button" className="link-button" onClick={backToLogin}>
                ← Back to Sign In
              </button>
            </p>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">👶</div>
          <h1 className="login-title">Staley Family Photos</h1>
          <p className="login-subtitle">Sign in to view photos</p>
        </div>

        <form className="login-form" onSubmit={handleLogin}>
          {error && <div className="error-banner">⚠️ {error}</div>}

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              className="form-input"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? "Signing in..." : "Sign In"}
          </button>

          <p className="signup-login-link">
            <button type="button" className="link-button" onClick={openForgotPassword}>
              Forgot password?
            </button>
          </p>
        </form>
      </div>
    </div>
  );
}
